import prisma from "@/lib/prisma";
import { TAX_NUMBER_STATUS } from "@/services/ecommerce/constants";

export const getManyTaxNumbers = async (options = {}) => {
  return prisma.ecommerceTaxNumber.findMany({
    where: {
      ...options,
    },
    omit: {
      id: true,
    },
    orderBy: [
      { updatedAt: "desc" },
      {
        createdAt: "desc",
      },
    ],
  });
};

export const getManyTaxNumbersForUser = async (userID) => {
  return await getManyTaxNumbers({
    userID,
  });
};

export const getSingleTaxNumberByTypeForUser = async (userID, { type }) => {
  return await prisma.ecommerceTaxNumber.findUnique({
    where: {
      ecommerce_tax_numbers_userID_type_unique: {
        userID,
        type,
      },
    },
  });
};

export const getApprovedTaxNumberByTypeForUser = async (userID, { type }) => {
  const taxData = await getSingleTaxNumberByTypeForUser(userID, { type });
  if (taxData?.status === TAX_NUMBER_STATUS.APPROVED.value) return taxData;

  return null;
};

export const upsertTaxNumber = async ({
  userID,
  type,
  number,
  status = TAX_NUMBER_STATUS.PENDING.value,
  rejectionReason = null,
}) => {
  const data = {
    number,
    status,
    rejectionReason:
      status === TAX_NUMBER_STATUS.REJECTED.value ? rejectionReason : null,
    approvedAt: status === TAX_NUMBER_STATUS.APPROVED.value ? new Date() : null,
    rejectedAt: status === TAX_NUMBER_STATUS.REJECTED.value ? new Date() : null,
  };

  return await prisma.ecommerceTaxNumber.upsert({
    where: {
      ecommerce_tax_numbers_userID_type_unique: {
        userID,
        type,
      },
    },
    update: data,
    create: {
      ...data,
      userID,
      type,
    },
  });
};
